exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__CloseButton__CloseIcon {\n  all: initial;\n  font-family: var(--font-family);\n}\n.DS__CloseButton__CloseIcon {\n  position: absolute;\n  top: 24px;\n  right: 24px;\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #7a869a;\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n}\n", ""]);

// exports
exports.locals = {
	"CloseIcon": "DS__CloseButton__CloseIcon"
};